import type { ReactNode } from 'react'
import * as Dialog from '@radix-ui/react-dialog'
import { X } from 'lucide-react'
import { useTranslation } from 'react-i18next'

/** Bottom sheet on phones, centered dialog from md and up. */
export function Sheet({
  open,
  onOpenChange,
  title,
  children,
}: {
  open: boolean
  onOpenChange: (open: boolean) => void
  title: string
  children: ReactNode
}) {
  const { t } = useTranslation()
  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/55 backdrop-blur-sm data-[state=open]:animate-[gx-fade_160ms_ease-out]" />
        <Dialog.Content
          aria-describedby={undefined}
          className="fixed inset-x-0 bottom-0 z-50 flex max-h-[88dvh] flex-col rounded-t-3xl border border-line-strong bg-surface-1 pb-[env(safe-area-inset-bottom)] shadow-pop outline-none data-[state=open]:animate-[gx-sheet_260ms_cubic-bezier(0.22,1,0.36,1)] md:inset-x-auto md:top-[12vh] md:bottom-auto md:left-1/2 md:max-h-[76vh] md:w-[min(92vw,30rem)] md:-translate-x-1/2 md:rounded-3xl md:data-[state=open]:animate-[gx-pop_200ms_cubic-bezier(0.22,1,0.36,1)]"
        >
          <div className="mx-auto mt-2.5 h-1 w-10 rounded-full bg-line-strong md:hidden" aria-hidden />
          <div className="flex items-center justify-between px-5 pt-3 pb-2 md:pt-5">
            <Dialog.Title className="text-base font-semibold">{title}</Dialog.Title>
            <Dialog.Close
              aria-label={t('common.close')}
              className="inline-flex size-9 items-center justify-center rounded-xl text-muted hover:bg-surface-2 hover:text-fg"
            >
              <X className="size-[1.1rem]" />
            </Dialog.Close>
          </div>
          {children}
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
